import {ChangeDetectionStrategy, Component, DestroyRef, effect, input, signal, ViewChild} from "@angular/core";
import {Språk} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Subject} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {MatFormFieldControl} from "@angular/material/form-field";
import {MatFormFieldControlProxy} from "../../../material/MatFormFieldControlProxy";
import {MatOption, MatSelect, MatSelectTrigger} from "@angular/material/select";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {Lokaleinformasjon} from "felles-ng2/tjenester/i18n/GjeldendeLokale";
import {LokaleKomponent} from "../../lokale/lokale";

const debug = initDebugger('SpråkVelgerKomponent');

/**
 * Skjemakomponent for å velge språk.
 */
@Component({
    selector: 'lokale-velger',
    templateUrl: 'lokale-velger.html',
    styleUrl: 'lokale-velger.scss',
    providers: [{
        provide: MatFormFieldControl,
        useFactory: (komponent: LokaleVelgerKomponent) => new MatFormFieldControlProxy(() => komponent.nedtrekksmeny, komponent.stateChanges),
        deps: [LokaleVelgerKomponent]
    }],
    imports: [
        ReactiveFormsModule,
        MatOption,
        MatSelect,
        MatSelectTrigger,
        TranslateModule,
        LokaleKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LokaleVelgerKomponent {

    @ViewChild('lokalevelger') private nedtrekksmeny!: MatSelect;

    skjemakontroll = input.required<FormControl<Språk>>();
    placeholder = input();

    standardPlaceholder: string;
    valgtLokale = signal<Lokaleinformasjon | null>(null);
    tilgjengeligeLokaler = [
        Lokaleinformasjon.fraJavaLocale(Språk.norsk_bokmål),
        Lokaleinformasjon.fraJavaLocale(Språk.norsk_nynorsk),
        Lokaleinformasjon.fraJavaLocale(Språk.engelsk)
    ];

    private readonly stateChanges = new Subject<void>();

    constructor(private destroyRef: DestroyRef, private oversettelser: Oversettelser) {
        this.standardPlaceholder = this.oversettelser.oversett(i18n('Velg språk'));
        effect(() => {
            this.skjemakontroll().valueChanges.pipe(takeUntilDestroyed(destroyRef)).subscribe(valgt => this.setValgtSpråk(valgt));
        });
    }

    erValgt(a: Språk, b: Språk): boolean {
        return a == b;
    }

    ngAfterViewInit(): void {
        this.nedtrekksmeny.stateChanges
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => this.stateChanges.next())
        this.setValgtSpråk(this.skjemakontroll().value);
    }

    //hjelpemetoder

    private setValgtSpråk(valgt: Språk) {
        this.valgtLokale.set(this.tilgjengeligeLokaler.find(kandidat => kandidat.språk == valgt) ?? null);
    }
}
